import React, { lazy } from 'react';
import {
  QueryProvider
} from '@thd-nucleus/data-sources';

export const QuickViewLazy = lazy(() => import(
  /* webpackChunkName: "quick-view" */
  '@thd-olt-component-react/quick-view'
).then((mod) => {
  const { QuickView } = mod;
  return {
    default: (props) => {
      const { defaultVariables } = props;
      return (
        <QueryProvider
          dataSource="catalog"
          cacheKey="package-product-details-quick-item"
          defaultVariables={defaultVariables}
        >
          <div className="quick-view-wrapper">
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <QuickView {...props} />
          </div>
        </QueryProvider>
      );
    }
  };
}));